import $cercaliagl$AssertionError from './cercaliagl/AssertionError';
import {assert as _cercaliagl_AssertionError$assert} from './cercaliagl/AssertionError';
import $cercaliagl$BaseFeature from './cercaliagl/BaseFeature';
import $cercaliagl$BaseObject from './cercaliagl/BaseObject';
import $cercaliagl$Bounds from './cercaliagl/Bounds';
import $cercaliagl$ContextMenu from './cercaliagl/ContextMenu';
import {Option as _cercaliagl_ContextMenu$Option} from './cercaliagl/ContextMenu';
import $cercaliagl$Feature from './cercaliagl/Feature';
import $cercaliagl$Geolocation from './cercaliagl/Geolocation';
import {Icon as _cercaliagl_Geolocation$Icon} from './cercaliagl/Geolocation';
import $cercaliagl$Icon from './cercaliagl/Icon';
import {createDefault as _cercaliagl_Icon$createDefault} from './cercaliagl/Icon';
import $cercaliagl$InfoMap from './cercaliagl/InfoMap';
import $cercaliagl$JaroWinkler from './cercaliagl/JaroWinkler';
import $cercaliagl$Label from './cercaliagl/Label';
import $cercaliagl$LonLat from './cercaliagl/LonLat';
import {DefaultMapControls as _cercaliagl_Map$DefaultMapControls} from './cercaliagl/Map';
import $cercaliagl$Map from './cercaliagl/Map';
import $cercaliagl$MapDistance from './cercaliagl/MapDistance';
import $cercaliagl$MapEventType from './cercaliagl/MapEventType';
import $cercaliagl$MapPois from './cercaliagl/MapPois';
import {EventType as _cercaliagl_MapRouting$EventType} from './cercaliagl/MapRouting';
import $cercaliagl$MapRouting from './cercaliagl/MapRouting';
import {MarkerType as _cercaliagl_MapRouting$MarkerType} from './cercaliagl/MapRouting';
import {MapRoutingEvent as _cercaliagl_MapRouting$MapRoutingEvent} from './cercaliagl/MapRouting';
import {RouteCalculatedEvent as _cercaliagl_MapRouting$RouteCalculatedEvent} from './cercaliagl/MapRouting';
import {ContextMenuEvent as _cercaliagl_MapRouting$ContextMenuEvent} from './cercaliagl/MapRouting';
import {SelectAltRouteEvent as _cercaliagl_MapRouting$SelectAltRouteEvent} from './cercaliagl/MapRouting';
import $cercaliagl$MapStyler from './cercaliagl/MapStyler';
import $cercaliagl$MapTypes from './cercaliagl/MapTypes';
import $cercaliagl$Marker from './cercaliagl/Marker';
import {Severity as _cercaliagl_Notification$Severity} from './cercaliagl/Notification';
import $cercaliagl$Notification from './cercaliagl/Notification';
import $cercaliagl$Popup from './cercaliagl/Popup';
import $cercaliagl$SimpleLabel from './cercaliagl/SimpleLabel';
import {getCountries as _cercaliagl_data$getCountries} from './cercaliagl/data';
import {getCategories as _cercaliagl_data$getCategories} from './cercaliagl/data';
import $cercaliagl$data from './cercaliagl/data';
import {i18n as _cercaliagl_dictionary$i18n} from './cercaliagl/dictionary';
import {createDictionary as _cercaliagl_dictionary$createDictionary} from './cercaliagl/dictionary';
import $cercaliagl$globals from './cercaliagl/globals';
import {VERSION as _cercaliagl_globals$VERSION} from './cercaliagl/globals';
import {API_TYPE as _cercaliagl_globals$API_TYPE} from './cercaliagl/globals';
import {MAPBOXGL_ACCESSTOKEN as _cercaliagl_globals$MAPBOXGL_ACCESSTOKEN} from './cercaliagl/globals';
import {KEY as _cercaliagl_globals$KEY} from './cercaliagl/globals';
import {LANG as _cercaliagl_globals$LANG} from './cercaliagl/globals';
import {PLUGINS_PARAM as _cercaliagl_globals$PLUGINS_PARAM} from './cercaliagl/globals';
import {HTTP_PROTOCOL as _cercaliagl_globals$HTTP_PROTOCOL} from './cercaliagl/globals';
import {LB_DOMAIN as _cercaliagl_globals$LB_DOMAIN} from './cercaliagl/globals';
import {API_DOMAIN as _cercaliagl_globals$API_DOMAIN} from './cercaliagl/globals';
import {SUGGEST_DOMAIN as _cercaliagl_globals$SUGGEST_DOMAIN} from './cercaliagl/globals';
import {DEFAULT_MARKER_ANCHOR as _cercaliagl_globals$DEFAULT_MARKER_ANCHOR} from './cercaliagl/globals';
import {DEFAULT_MARKER_OFFSET as _cercaliagl_globals$DEFAULT_MARKER_OFFSET} from './cercaliagl/globals';
import {CDN_SUBDOMAINS as _cercaliagl_globals$CDN_SUBDOMAINS} from './cercaliagl/globals';
import {DEFAULT_POPUP_ANCHOR as _cercaliagl_globals$DEFAULT_POPUP_ANCHOR} from './cercaliagl/globals';
import {DEFAULT_POPUP_OFFSET as _cercaliagl_globals$DEFAULT_POPUP_OFFSET} from './cercaliagl/globals';
import {DEFAULT_ZOOM as _cercaliagl_globals$DEFAULT_ZOOM} from './cercaliagl/globals';
import {DEFAULT_MIN_ZOOM as _cercaliagl_globals$DEFAULT_MIN_ZOOM} from './cercaliagl/globals';
import {DEFAULT_MAX_ZOOM as _cercaliagl_globals$DEFAULT_MAX_ZOOM} from './cercaliagl/globals';
import {DEFAULT_CENTER as _cercaliagl_globals$DEFAULT_CENTER} from './cercaliagl/globals';
import {ZOOM_AUTOENABLE_BUILDINGS as _cercaliagl_globals$ZOOM_AUTOENABLE_BUILDINGS} from './cercaliagl/globals';
import {IS_MOBILE as _cercaliagl_globals$IS_MOBILE} from './cercaliagl/globals';
import {THEME as _cercaliagl_globals$THEME} from './cercaliagl/globals';
import {URL_DATA_MODELS as _cercaliagl_globals$URL_DATA_MODELS} from './cercaliagl/globals';
import {CountriesPortalBefore as _cercaliagl_globals$CountriesPortalBefore} from './cercaliagl/globals';
import {IMG as _cercaliagl_globals$IMG} from './cercaliagl/globals';
import {STYLES as _cercaliagl_globals$STYLES} from './cercaliagl/globals';
import {setAuthkey as _cercaliagl_globals$setAuthkey} from './cercaliagl/globals';
import {getAuthkey as _cercaliagl_globals$getAuthkey} from './cercaliagl/globals';
import {SPAIN_BOUNDS as _cercaliagl_globals$SPAIN_BOUNDS} from './cercaliagl/globals';
import {CANARY_ISLANDS_BOUNDS as _cercaliagl_globals$CANARY_ISLANDS_BOUNDS} from './cercaliagl/globals';
import $cercaliagl$plugins from './cercaliagl/plugins';
import {PLUGINS_URL as _cercaliagl_plugins$PLUGINS_URL} from './cercaliagl/plugins';
import {loadPlugin as _cercaliagl_plugins$loadPlugin} from './cercaliagl/plugins';
import {loadPlugins as _cercaliagl_plugins$loadPlugins} from './cercaliagl/plugins';
import {checkPluginLoaded as _cercaliagl_plugins$checkPluginLoaded} from './cercaliagl/plugins';
import {isMobile as _cercaliagl_util$isMobile} from './cercaliagl/util';
import {createUid as _cercaliagl_util$createUid} from './cercaliagl/util';
import {toRadians as _cercaliagl_util$toRadians} from './cercaliagl/util';
import {createCircleGeometry as _cercaliagl_util$createCircleGeometry} from './cercaliagl/util';
import {distanceBetweenPoints as _cercaliagl_util$distanceBetweenPoints} from './cercaliagl/util';
import {distanceTo as _cercaliagl_util$distanceTo} from './cercaliagl/util';
import {wktToArrayCoordinates as _cercaliagl_util$wktToArrayCoordinates} from './cercaliagl/util';
import {getFilename as _cercaliagl_util$getFilename} from './cercaliagl/util';
import {isOnBase64 as _cercaliagl_util$isOnBase64} from './cercaliagl/util';
import {countWords as _cercaliagl_util$countWords} from './cercaliagl/util';
import $cercaliagl$util from './cercaliagl/util';
import {convertDmsToDecimal as _cercaliagl_util$convertDmsToDecimal} from './cercaliagl/util';
import {getProximityFormattedAddress as _cercaliagl_util$getProximityFormattedAddress} from './cercaliagl/util';
import {distanceMetricToImperial as _cercaliagl_util$distanceMetricToImperial} from './cercaliagl/util';
import {areaMetricToImperial as _cercaliagl_util$areaMetricToImperial} from './cercaliagl/util';
import {cloneDeep as _cercaliagl_util$cloneDeep} from './cercaliagl/util';
import {transformWktToKML as _cercaliagl_util$transformWktToKML} from './cercaliagl/util';
import {downloadXmlToFile as _cercaliagl_util$downloadXmlToFile} from './cercaliagl/util';
import {downloadKmlFromWkt as _cercaliagl_util$downloadKmlFromWkt} from './cercaliagl/util';
import {formatAddress as _cercaliagl_util$formatAddress} from './cercaliagl/util';
import {hhmmssToSeconds as _cercaliagl_util$hhmmssToSeconds} from './cercaliagl/util';
import {normalizeTime as _cercaliagl_util$normalizeTime} from './cercaliagl/util';
import {normalizeDistance as _cercaliagl_util$normalizeDistance} from './cercaliagl/util';
import {normalizeDistMeters as _cercaliagl_util$normalizeDistMeters} from './cercaliagl/util';
import {wktToGeometry as _cercaliagl_util$wktToGeometry} from './cercaliagl/util';
import {geojsonToWKT as _cercaliagl_util$geojsonToWKT} from './cercaliagl/util';
import {wktLinestringToPolygonBuffered as _cercaliagl_util$wktLinestringToPolygonBuffered} from './cercaliagl/util';
import {getClosestLonLatOfFeature as _cercaliagl_util$getClosestLonLatOfFeature} from './cercaliagl/util';
import {getClosestFeatureByPosition as _cercaliagl_util$getClosestFeatureByPosition} from './cercaliagl/util';
import {geofencing as _cercaliagl_util$geofencing} from './cercaliagl/util';
import {createMaplibreSimpleMarker as _cercaliagl_util$createMaplibreSimpleMarker} from './cercaliagl/util';
import {donutSegment as _cercaliagl_util$donutSegment} from './cercaliagl/util';
import {createDonutChart as _cercaliagl_util$createDonutChart} from './cercaliagl/util';
import {textRemoveHTMLTags as _cercaliagl_util$textRemoveHTMLTags} from './cercaliagl/util';
import {isNumber as _cercaliagl_util$isNumber} from './cercaliagl/util';
import {binarySearchZIndex as _cercaliagl_util$binarySearchZIndex} from './cercaliagl/util';
import {checkPolygonSegmentIntersection as _cercaliagl_util$checkPolygonSegmentIntersection} from './cercaliagl/util';
import {getLinestringIntersectionsWithPolygon as _cercaliagl_util$getLinestringIntersectionsWithPolygon} from './cercaliagl/util';
import {getPartialLinestring as _cercaliagl_util$getPartialLinestring} from './cercaliagl/util';
import {transformWKT as _cercaliagl_util$transformWKT} from './cercaliagl/util';
import {getAnchorStringEquivalent as _cercaliagl_util$getAnchorStringEquivalent} from './cercaliagl/util';
import $cercaliagl$view$BaseView from './cercaliagl/view/BaseView';
import {createSVGIconFromPath as _cercaliagl_view_SVGUtils$createSVGIconFromPath} from './cercaliagl/view/SVGUtils';
import {createSVGIcon as _cercaliagl_view_SVGUtils$createSVGIcon} from './cercaliagl/view/SVGUtils';
import {createSpanIconByNumPath as _cercaliagl_view_SVGUtils$createSpanIconByNumPath} from './cercaliagl/view/SVGUtils';
import $cercaliagl$view$VAddress from './cercaliagl/view/VAddress';
import $cercaliagl$view$VAutocomplete from './cercaliagl/view/VAutocomplete';
import $cercaliagl$view$VContextMenu from './cercaliagl/view/VContextMenu';
import $cercaliagl$view$VControlButton from './cercaliagl/view/VControlButton';
import $cercaliagl$view$VDropDownMultiple from './cercaliagl/view/VDropDownMultiple';
import $cercaliagl$view$VGasStationPopup from './cercaliagl/view/VGasStationPopup';
import $cercaliagl$view$VInfoMap from './cercaliagl/view/VInfoMap';
import $cercaliagl$view$VIsochrones from './cercaliagl/view/VIsochrones';
import $cercaliagl$view$VLayerSwitcher from './cercaliagl/view/VLayerSwitcher';
import $cercaliagl$view$VLogisticRestrictions from './cercaliagl/view/VLogisticRestrictions';
import $cercaliagl$view$VMeteoPopup from './cercaliagl/view/VMeteoPopup';
import $cercaliagl$view$VNavBar from './cercaliagl/view/VNavBar';
import {Buttons as _cercaliagl_view_VNavBar$Buttons} from './cercaliagl/view/VNavBar';
import $cercaliagl$view$VNotification from './cercaliagl/view/VNotification';
import $cercaliagl$view$VShadowBuildings from './cercaliagl/view/VShadowBuildings';
import $cercaliagl$view$VStreetView from './cercaliagl/view/VStreetView';
import $cercaliagl$view$VTraffic from './cercaliagl/view/VTraffic';
import $cercaliagl$view$VTrafficPopup from './cercaliagl/view/VTrafficPopup';
import {getDOMRelativePosition as _cercaliagl_view_VUtils$getDOMRelativePosition} from './cercaliagl/view/VUtils';
import {isMobile as _cercaliagl_view_VUtils$isMobile} from './cercaliagl/view/VUtils';
import {createCheckbox as _cercaliagl_view_VUtils$createCheckbox} from './cercaliagl/view/VUtils';
import {createTabBar as _cercaliagl_view_VUtils$createTabBar} from './cercaliagl/view/VUtils';
import {createCircleStop as _cercaliagl_view_VUtils$createCircleStop} from './cercaliagl/view/VUtils';
import {createRadiobox as _cercaliagl_view_VUtils$createRadiobox} from './cercaliagl/view/VUtils';
import {createSwitch as _cercaliagl_view_VUtils$createSwitch} from './cercaliagl/view/VUtils';
import $cercaliagl$view$VUtils from './cercaliagl/view/VUtils';
import {createInputDate as _cercaliagl_view_VUtils$createInputDate} from './cercaliagl/view/VUtils';
import {createInputTime as _cercaliagl_view_VUtils$createInputTime} from './cercaliagl/view/VUtils';
import {createCheckboxIconInput as _cercaliagl_view_VUtils$createCheckboxIconInput} from './cercaliagl/view/VUtils';
import {createProgressBar as _cercaliagl_view_VUtils$createProgressBar} from './cercaliagl/view/VUtils';
import {createSlider as _cercaliagl_view_VUtils$createSlider} from './cercaliagl/view/VUtils';
import {createSelectOptionItem as _cercaliagl_view_VUtils$createSelectOptionItem} from './cercaliagl/view/VUtils';
import {createSelect as _cercaliagl_view_VUtils$createSelect} from './cercaliagl/view/VUtils';
import {createFilledTextField as _cercaliagl_view_VUtils$createFilledTextField} from './cercaliagl/view/VUtils';
import {createTextButton as _cercaliagl_view_VUtils$createTextButton} from './cercaliagl/view/VUtils';
import {createIconButton as _cercaliagl_view_VUtils$createIconButton} from './cercaliagl/view/VUtils';
import {createTextFieldWithSuffix as _cercaliagl_view_VUtils$createTextFieldWithSuffix} from './cercaliagl/view/VUtils';
import {formatDate as _cercaliagl_view_VUtils$formatDate} from './cercaliagl/view/VUtils';
import $cercaliagl$view$VWeatherInformation from './cercaliagl/view/VWeatherInformation';
import $cercaliagl$view$VWidgetPois from './cercaliagl/view/VWidgetPois';
import $cercaliagl$view$VWidgetRouting from './cercaliagl/view/VWidgetRouting';
import $cercaliagl$view$VWidgetSearch from './cercaliagl/view/VWidgetSearch';
import $cercaliagl$view$VZBEPopup from './cercaliagl/view/VZBEPopup';
import $cercaliagl$view$VZoom from './cercaliagl/view/VZoom';
import $cercaliagl$service$Autocomplete from './cercaliagl/service/Autocomplete';
import $cercaliagl$service$Distance from './cercaliagl/service/Distance';
import $cercaliagl$service$Geocoding from './cercaliagl/service/Geocoding';
import $cercaliagl$service$GeometryEntity from './cercaliagl/service/GeometryEntity';
import {Weight as _cercaliagl_service_Isochrone$Weight} from './cercaliagl/service/Isochrone';
import $cercaliagl$service$Isochrone from './cercaliagl/service/Isochrone';
import {Methods as _cercaliagl_service_Isochrone$Methods} from './cercaliagl/service/Isochrone';
import $cercaliagl$service$Pois from './cercaliagl/service/Pois';
import $cercaliagl$service$Proximity from './cercaliagl/service/Proximity';
import $cercaliagl$service$ReverseGeocoding from './cercaliagl/service/ReverseGeocoding';
import $cercaliagl$service$Routing from './cercaliagl/service/Routing';
import $cercaliagl$service$Service from './cercaliagl/service/Service';
import $cercaliagl$layer$Base from './cercaliagl/layer/Base';
import $cercaliagl$layer$Feature from './cercaliagl/layer/Feature';
import $cercaliagl$layer$LandMarks3D from './cercaliagl/layer/LandMarks3D';
import $cercaliagl$layer$Manager from './cercaliagl/layer/Manager';
import $cercaliagl$layer$Marker from './cercaliagl/layer/Marker';
import $cercaliagl$layer$RainWeather from './cercaliagl/layer/RainWeather';
import $cercaliagl$layer$TrafficForecast from './cercaliagl/layer/TrafficForecast';
import $cercaliagl$layer$TrafficLive from './cercaliagl/layer/TrafficLive';
import $cercaliagl$layer$WMS from './cercaliagl/layer/WMS';
import $cercaliagl$layer$XYZ from './cercaliagl/layer/XYZ';
import $cercaliagl$layer$ZBE from './cercaliagl/layer/ZBE';
import {Type as _cercaliagl_interaction_Draw$Type} from './cercaliagl/interaction/Draw';
import $cercaliagl$interaction$Draw from './cercaliagl/interaction/Draw';
import $cercaliagl$interaction$FreehandDraw from './cercaliagl/interaction/FreehandDraw';
import $cercaliagl$control$Address from './cercaliagl/control/Address';
import $cercaliagl$control$Buildings3D from './cercaliagl/control/Buildings3D';
import $cercaliagl$control$Clean from './cercaliagl/control/Clean';
import $cercaliagl$control$Control from './cercaliagl/control/Control';
import $cercaliagl$control$Custom from './cercaliagl/control/Custom';
import $cercaliagl$control$Draw from './cercaliagl/control/Draw';
import $cercaliagl$control$FullScreen from './cercaliagl/control/FullScreen';
import {Options as _cercaliagl_control_GasStations$Options} from './cercaliagl/control/GasStations';
import $cercaliagl$control$GasStations from './cercaliagl/control/GasStations';
import $cercaliagl$control$InfoMap from './cercaliagl/control/InfoMap';
import $cercaliagl$control$Isochrones from './cercaliagl/control/Isochrones';
import $cercaliagl$control$LayerRegions from './cercaliagl/control/LayerRegions';
import $cercaliagl$control$LayerRegionsOptions from './cercaliagl/control/LayerRegionsOptions';
import $cercaliagl$control$LayerSwitcher from './cercaliagl/control/LayerSwitcher';
import $cercaliagl$control$LogisticRestrictions from './cercaliagl/control/LogisticRestrictions';
import $cercaliagl$control$Logo from './cercaliagl/control/Logo';
import $cercaliagl$control$MapControls from './cercaliagl/control/MapControls';
import {Options as _cercaliagl_control_Meteo$Options} from './cercaliagl/control/Meteo';
import $cercaliagl$control$Meteo from './cercaliagl/control/Meteo';
import {Buttons as _cercaliagl_control_NavBar$Buttons} from './cercaliagl/control/NavBar';
import $cercaliagl$control$NavBar from './cercaliagl/control/NavBar';
import $cercaliagl$control$StreetView from './cercaliagl/control/StreetView';
import {Options as _cercaliagl_control_Traffic$Options} from './cercaliagl/control/Traffic';
import $cercaliagl$control$Traffic from './cercaliagl/control/Traffic';
import $cercaliagl$control$ViewInterface from './cercaliagl/control/ViewInterface';
import $cercaliagl$control$ZBE from './cercaliagl/control/ZBE';
import $cercaliagl$control$Zoom from './cercaliagl/control/Zoom';

var cercaliagl = {};
cercaliagl.AssertionError = $cercaliagl$AssertionError || {};
cercaliagl.AssertionError.assert = _cercaliagl_AssertionError$assert || {};
cercaliagl.BaseFeature = $cercaliagl$BaseFeature || {};
cercaliagl.BaseObject = $cercaliagl$BaseObject || {};
cercaliagl.Bounds = $cercaliagl$Bounds || {};
cercaliagl.ContextMenu = $cercaliagl$ContextMenu || {};
cercaliagl.ContextMenu.Option = _cercaliagl_ContextMenu$Option || {};
cercaliagl.Feature = $cercaliagl$Feature || {};
cercaliagl.Geolocation = $cercaliagl$Geolocation || {};
cercaliagl.Geolocation.Icon = _cercaliagl_Geolocation$Icon || {};
cercaliagl.Icon = $cercaliagl$Icon || {};
cercaliagl.Icon.createDefault = _cercaliagl_Icon$createDefault || {};
cercaliagl.InfoMap = $cercaliagl$InfoMap || {};
cercaliagl.JaroWinkler = $cercaliagl$JaroWinkler || {};
cercaliagl.Label = $cercaliagl$Label || {};
cercaliagl.LonLat = $cercaliagl$LonLat || {};
cercaliagl.Map = $cercaliagl$Map || {};
cercaliagl.Map.DefaultMapControls = _cercaliagl_Map$DefaultMapControls || {};
cercaliagl.MapDistance = $cercaliagl$MapDistance || {};
cercaliagl.MapEventType = $cercaliagl$MapEventType || {};
cercaliagl.MapPois = $cercaliagl$MapPois || {};
cercaliagl.MapRouting = $cercaliagl$MapRouting || {};
cercaliagl.MapRouting.ContextMenuEvent = _cercaliagl_MapRouting$ContextMenuEvent || {};
cercaliagl.MapRouting.EventType = _cercaliagl_MapRouting$EventType || {};
cercaliagl.MapRouting.MapRoutingEvent = _cercaliagl_MapRouting$MapRoutingEvent || {};
cercaliagl.MapRouting.MarkerType = _cercaliagl_MapRouting$MarkerType || {};
cercaliagl.MapRouting.RouteCalculatedEvent = _cercaliagl_MapRouting$RouteCalculatedEvent || {};
cercaliagl.MapRouting.SelectAltRouteEvent = _cercaliagl_MapRouting$SelectAltRouteEvent || {};
cercaliagl.MapStyler = $cercaliagl$MapStyler || {};
cercaliagl.MapTypes = $cercaliagl$MapTypes || {};
cercaliagl.Marker = $cercaliagl$Marker || {};
cercaliagl.Notification = $cercaliagl$Notification || {};
cercaliagl.Notification.Severity = _cercaliagl_Notification$Severity || {};
cercaliagl.Popup = $cercaliagl$Popup || {};
cercaliagl.SimpleLabel = $cercaliagl$SimpleLabel || {};
cercaliagl.control = {};
cercaliagl.control.Address = $cercaliagl$control$Address || {};
cercaliagl.control.Buildings3D = $cercaliagl$control$Buildings3D || {};
cercaliagl.control.Clean = $cercaliagl$control$Clean || {};
cercaliagl.control.Control = $cercaliagl$control$Control || {};
cercaliagl.control.Custom = $cercaliagl$control$Custom || {};
cercaliagl.control.Draw = $cercaliagl$control$Draw || {};
cercaliagl.control.FullScreen = $cercaliagl$control$FullScreen || {};
cercaliagl.control.GasStations = $cercaliagl$control$GasStations || {};
cercaliagl.control.GasStations.Options = _cercaliagl_control_GasStations$Options || {};
cercaliagl.control.InfoMap = $cercaliagl$control$InfoMap || {};
cercaliagl.control.Isochrones = $cercaliagl$control$Isochrones || {};
cercaliagl.control.LayerRegions = $cercaliagl$control$LayerRegions || {};
cercaliagl.control.LayerRegionsOptions = $cercaliagl$control$LayerRegionsOptions || {};
cercaliagl.control.LayerSwitcher = $cercaliagl$control$LayerSwitcher || {};
cercaliagl.control.LogisticRestrictions = $cercaliagl$control$LogisticRestrictions || {};
cercaliagl.control.Logo = $cercaliagl$control$Logo || {};
cercaliagl.control.MapControls = $cercaliagl$control$MapControls || {};
cercaliagl.control.Meteo = $cercaliagl$control$Meteo || {};
cercaliagl.control.Meteo.Options = _cercaliagl_control_Meteo$Options || {};
cercaliagl.control.NavBar = $cercaliagl$control$NavBar || {};
cercaliagl.control.NavBar.Buttons = _cercaliagl_control_NavBar$Buttons || {};
cercaliagl.control.StreetView = $cercaliagl$control$StreetView || {};
cercaliagl.control.Traffic = $cercaliagl$control$Traffic || {};
cercaliagl.control.Traffic.Options = _cercaliagl_control_Traffic$Options || {};
cercaliagl.control.ViewInterface = $cercaliagl$control$ViewInterface || {};
cercaliagl.control.ZBE = $cercaliagl$control$ZBE || {};
cercaliagl.control.Zoom = $cercaliagl$control$Zoom || {};
cercaliagl.data = $cercaliagl$data || {};
cercaliagl.data.getCategories = _cercaliagl_data$getCategories || {};
cercaliagl.data.getCountries = _cercaliagl_data$getCountries || {};
cercaliagl.dictionary = {};
cercaliagl.dictionary.createDictionary = _cercaliagl_dictionary$createDictionary || {};
cercaliagl.dictionary.i18n = _cercaliagl_dictionary$i18n || {};
cercaliagl.globals = $cercaliagl$globals || {};
cercaliagl.globals.API_DOMAIN = _cercaliagl_globals$API_DOMAIN || {};
cercaliagl.globals.API_TYPE = _cercaliagl_globals$API_TYPE || {};
cercaliagl.globals.CANARY_ISLANDS_BOUNDS = _cercaliagl_globals$CANARY_ISLANDS_BOUNDS || {};
cercaliagl.globals.CDN_SUBDOMAINS = _cercaliagl_globals$CDN_SUBDOMAINS || {};
cercaliagl.globals.CountriesPortalBefore = _cercaliagl_globals$CountriesPortalBefore || {};
cercaliagl.globals.DEFAULT_CENTER = _cercaliagl_globals$DEFAULT_CENTER || {};
cercaliagl.globals.DEFAULT_MARKER_ANCHOR = _cercaliagl_globals$DEFAULT_MARKER_ANCHOR || {};
cercaliagl.globals.DEFAULT_MARKER_OFFSET = _cercaliagl_globals$DEFAULT_MARKER_OFFSET || {};
cercaliagl.globals.DEFAULT_MAX_ZOOM = _cercaliagl_globals$DEFAULT_MAX_ZOOM || {};
cercaliagl.globals.DEFAULT_MIN_ZOOM = _cercaliagl_globals$DEFAULT_MIN_ZOOM || {};
cercaliagl.globals.DEFAULT_POPUP_ANCHOR = _cercaliagl_globals$DEFAULT_POPUP_ANCHOR || {};
cercaliagl.globals.DEFAULT_POPUP_OFFSET = _cercaliagl_globals$DEFAULT_POPUP_OFFSET || {};
cercaliagl.globals.DEFAULT_ZOOM = _cercaliagl_globals$DEFAULT_ZOOM || {};
cercaliagl.globals.HTTP_PROTOCOL = _cercaliagl_globals$HTTP_PROTOCOL || {};
cercaliagl.globals.IMG = _cercaliagl_globals$IMG || {};
cercaliagl.globals.IS_MOBILE = _cercaliagl_globals$IS_MOBILE || {};
cercaliagl.globals.KEY = _cercaliagl_globals$KEY || {};
cercaliagl.globals.LANG = _cercaliagl_globals$LANG || {};
cercaliagl.globals.LB_DOMAIN = _cercaliagl_globals$LB_DOMAIN || {};
cercaliagl.globals.MAPBOXGL_ACCESSTOKEN = _cercaliagl_globals$MAPBOXGL_ACCESSTOKEN || {};
cercaliagl.globals.PLUGINS_PARAM = _cercaliagl_globals$PLUGINS_PARAM || {};
cercaliagl.globals.SPAIN_BOUNDS = _cercaliagl_globals$SPAIN_BOUNDS || {};
cercaliagl.globals.STYLES = _cercaliagl_globals$STYLES || {};
cercaliagl.globals.SUGGEST_DOMAIN = _cercaliagl_globals$SUGGEST_DOMAIN || {};
cercaliagl.globals.THEME = _cercaliagl_globals$THEME || {};
cercaliagl.globals.URL_DATA_MODELS = _cercaliagl_globals$URL_DATA_MODELS || {};
cercaliagl.globals.VERSION = _cercaliagl_globals$VERSION || {};
cercaliagl.globals.ZOOM_AUTOENABLE_BUILDINGS = _cercaliagl_globals$ZOOM_AUTOENABLE_BUILDINGS || {};
cercaliagl.globals.getAuthkey = _cercaliagl_globals$getAuthkey || {};
cercaliagl.globals.setAuthkey = _cercaliagl_globals$setAuthkey || {};
cercaliagl.interaction = {};
cercaliagl.interaction.Draw = $cercaliagl$interaction$Draw || {};
cercaliagl.interaction.Draw.Type = _cercaliagl_interaction_Draw$Type || {};
cercaliagl.interaction.FreehandDraw = $cercaliagl$interaction$FreehandDraw || {};
cercaliagl.layer = {};
cercaliagl.layer.Base = $cercaliagl$layer$Base || {};
cercaliagl.layer.Feature = $cercaliagl$layer$Feature || {};
cercaliagl.layer.LandMarks3D = $cercaliagl$layer$LandMarks3D || {};
cercaliagl.layer.Manager = $cercaliagl$layer$Manager || {};
cercaliagl.layer.Marker = $cercaliagl$layer$Marker || {};
cercaliagl.layer.RainWeather = $cercaliagl$layer$RainWeather || {};
cercaliagl.layer.TrafficForecast = $cercaliagl$layer$TrafficForecast || {};
cercaliagl.layer.TrafficLive = $cercaliagl$layer$TrafficLive || {};
cercaliagl.layer.WMS = $cercaliagl$layer$WMS || {};
cercaliagl.layer.XYZ = $cercaliagl$layer$XYZ || {};
cercaliagl.layer.ZBE = $cercaliagl$layer$ZBE || {};
cercaliagl.plugins = $cercaliagl$plugins || {};
cercaliagl.plugins.PLUGINS_URL = _cercaliagl_plugins$PLUGINS_URL || {};
cercaliagl.plugins.checkPluginLoaded = _cercaliagl_plugins$checkPluginLoaded || {};
cercaliagl.plugins.loadPlugin = _cercaliagl_plugins$loadPlugin || {};
cercaliagl.plugins.loadPlugins = _cercaliagl_plugins$loadPlugins || {};
cercaliagl.service = {};
cercaliagl.service.Autocomplete = $cercaliagl$service$Autocomplete || {};
cercaliagl.service.Distance = $cercaliagl$service$Distance || {};
cercaliagl.service.Geocoding = $cercaliagl$service$Geocoding || {};
cercaliagl.service.GeometryEntity = $cercaliagl$service$GeometryEntity || {};
cercaliagl.service.Isochrone = $cercaliagl$service$Isochrone || {};
cercaliagl.service.Isochrone.Methods = _cercaliagl_service_Isochrone$Methods || {};
cercaliagl.service.Isochrone.Weight = _cercaliagl_service_Isochrone$Weight || {};
cercaliagl.service.Pois = $cercaliagl$service$Pois || {};
cercaliagl.service.Proximity = $cercaliagl$service$Proximity || {};
cercaliagl.service.ReverseGeocoding = $cercaliagl$service$ReverseGeocoding || {};
cercaliagl.service.Routing = $cercaliagl$service$Routing || {};
cercaliagl.service.Service = $cercaliagl$service$Service || {};
cercaliagl.util = $cercaliagl$util || {};
cercaliagl.util.areaMetricToImperial = _cercaliagl_util$areaMetricToImperial || {};
cercaliagl.util.binarySearchZIndex = _cercaliagl_util$binarySearchZIndex || {};
cercaliagl.util.checkPolygonSegmentIntersection = _cercaliagl_util$checkPolygonSegmentIntersection || {};
cercaliagl.util.cloneDeep = _cercaliagl_util$cloneDeep || {};
cercaliagl.util.convertDmsToDecimal = _cercaliagl_util$convertDmsToDecimal || {};
cercaliagl.util.countWords = _cercaliagl_util$countWords || {};
cercaliagl.util.createCircleGeometry = _cercaliagl_util$createCircleGeometry || {};
cercaliagl.util.createDonutChart = _cercaliagl_util$createDonutChart || {};
cercaliagl.util.createMaplibreSimpleMarker = _cercaliagl_util$createMaplibreSimpleMarker || {};
cercaliagl.util.createUid = _cercaliagl_util$createUid || {};
cercaliagl.util.distanceBetweenPoints = _cercaliagl_util$distanceBetweenPoints || {};
cercaliagl.util.distanceMetricToImperial = _cercaliagl_util$distanceMetricToImperial || {};
cercaliagl.util.distanceTo = _cercaliagl_util$distanceTo || {};
cercaliagl.util.donutSegment = _cercaliagl_util$donutSegment || {};
cercaliagl.util.downloadKmlFromWkt = _cercaliagl_util$downloadKmlFromWkt || {};
cercaliagl.util.downloadXmlToFile = _cercaliagl_util$downloadXmlToFile || {};
cercaliagl.util.formatAddress = _cercaliagl_util$formatAddress || {};
cercaliagl.util.geofencing = _cercaliagl_util$geofencing || {};
cercaliagl.util.geojsonToWKT = _cercaliagl_util$geojsonToWKT || {};
cercaliagl.util.getAnchorStringEquivalent = _cercaliagl_util$getAnchorStringEquivalent || {};
cercaliagl.util.getClosestFeatureByPosition = _cercaliagl_util$getClosestFeatureByPosition || {};
cercaliagl.util.getClosestLonLatOfFeature = _cercaliagl_util$getClosestLonLatOfFeature || {};
cercaliagl.util.getFilename = _cercaliagl_util$getFilename || {};
cercaliagl.util.getLinestringIntersectionsWithPolygon = _cercaliagl_util$getLinestringIntersectionsWithPolygon || {};
cercaliagl.util.getPartialLinestring = _cercaliagl_util$getPartialLinestring || {};
cercaliagl.util.getProximityFormattedAddress = _cercaliagl_util$getProximityFormattedAddress || {};
cercaliagl.util.hhmmssToSeconds = _cercaliagl_util$hhmmssToSeconds || {};
cercaliagl.util.isMobile = _cercaliagl_util$isMobile || {};
cercaliagl.util.isNumber = _cercaliagl_util$isNumber || {};
cercaliagl.util.isOnBase64 = _cercaliagl_util$isOnBase64 || {};
cercaliagl.util.normalizeDistMeters = _cercaliagl_util$normalizeDistMeters || {};
cercaliagl.util.normalizeDistance = _cercaliagl_util$normalizeDistance || {};
cercaliagl.util.normalizeTime = _cercaliagl_util$normalizeTime || {};
cercaliagl.util.textRemoveHTMLTags = _cercaliagl_util$textRemoveHTMLTags || {};
cercaliagl.util.toRadians = _cercaliagl_util$toRadians || {};
cercaliagl.util.transformWKT = _cercaliagl_util$transformWKT || {};
cercaliagl.util.transformWktToKML = _cercaliagl_util$transformWktToKML || {};
cercaliagl.util.wktLinestringToPolygonBuffered = _cercaliagl_util$wktLinestringToPolygonBuffered || {};
cercaliagl.util.wktToArrayCoordinates = _cercaliagl_util$wktToArrayCoordinates || {};
cercaliagl.util.wktToGeometry = _cercaliagl_util$wktToGeometry || {};
cercaliagl.view = {};
cercaliagl.view.BaseView = $cercaliagl$view$BaseView || {};
cercaliagl.view.SVGUtils = {};
cercaliagl.view.SVGUtils.createSVGIcon = _cercaliagl_view_SVGUtils$createSVGIcon || {};
cercaliagl.view.SVGUtils.createSVGIconFromPath = _cercaliagl_view_SVGUtils$createSVGIconFromPath || {};
cercaliagl.view.SVGUtils.createSpanIconByNumPath = _cercaliagl_view_SVGUtils$createSpanIconByNumPath || {};
cercaliagl.view.VAddress = $cercaliagl$view$VAddress || {};
cercaliagl.view.VAutocomplete = $cercaliagl$view$VAutocomplete || {};
cercaliagl.view.VContextMenu = $cercaliagl$view$VContextMenu || {};
cercaliagl.view.VControlButton = $cercaliagl$view$VControlButton || {};
cercaliagl.view.VDropDownMultiple = $cercaliagl$view$VDropDownMultiple || {};
cercaliagl.view.VGasStationPopup = $cercaliagl$view$VGasStationPopup || {};
cercaliagl.view.VInfoMap = $cercaliagl$view$VInfoMap || {};
cercaliagl.view.VIsochrones = $cercaliagl$view$VIsochrones || {};
cercaliagl.view.VLayerSwitcher = $cercaliagl$view$VLayerSwitcher || {};
cercaliagl.view.VLogisticRestrictions = $cercaliagl$view$VLogisticRestrictions || {};
cercaliagl.view.VMeteoPopup = $cercaliagl$view$VMeteoPopup || {};
cercaliagl.view.VNavBar = $cercaliagl$view$VNavBar || {};
cercaliagl.view.VNavBar.Buttons = _cercaliagl_view_VNavBar$Buttons || {};
cercaliagl.view.VNotification = $cercaliagl$view$VNotification || {};
cercaliagl.view.VShadowBuildings = $cercaliagl$view$VShadowBuildings || {};
cercaliagl.view.VStreetView = $cercaliagl$view$VStreetView || {};
cercaliagl.view.VTraffic = $cercaliagl$view$VTraffic || {};
cercaliagl.view.VTrafficPopup = $cercaliagl$view$VTrafficPopup || {};
cercaliagl.view.VUtils = $cercaliagl$view$VUtils || {};
cercaliagl.view.VUtils.createCheckbox = _cercaliagl_view_VUtils$createCheckbox || {};
cercaliagl.view.VUtils.createCheckboxIconInput = _cercaliagl_view_VUtils$createCheckboxIconInput || {};
cercaliagl.view.VUtils.createCircleStop = _cercaliagl_view_VUtils$createCircleStop || {};
cercaliagl.view.VUtils.createFilledTextField = _cercaliagl_view_VUtils$createFilledTextField || {};
cercaliagl.view.VUtils.createIconButton = _cercaliagl_view_VUtils$createIconButton || {};
cercaliagl.view.VUtils.createInputDate = _cercaliagl_view_VUtils$createInputDate || {};
cercaliagl.view.VUtils.createInputTime = _cercaliagl_view_VUtils$createInputTime || {};
cercaliagl.view.VUtils.createProgressBar = _cercaliagl_view_VUtils$createProgressBar || {};
cercaliagl.view.VUtils.createRadiobox = _cercaliagl_view_VUtils$createRadiobox || {};
cercaliagl.view.VUtils.createSelect = _cercaliagl_view_VUtils$createSelect || {};
cercaliagl.view.VUtils.createSelectOptionItem = _cercaliagl_view_VUtils$createSelectOptionItem || {};
cercaliagl.view.VUtils.createSlider = _cercaliagl_view_VUtils$createSlider || {};
cercaliagl.view.VUtils.createSwitch = _cercaliagl_view_VUtils$createSwitch || {};
cercaliagl.view.VUtils.createTabBar = _cercaliagl_view_VUtils$createTabBar || {};
cercaliagl.view.VUtils.createTextButton = _cercaliagl_view_VUtils$createTextButton || {};
cercaliagl.view.VUtils.createTextFieldWithSuffix = _cercaliagl_view_VUtils$createTextFieldWithSuffix || {};
cercaliagl.view.VUtils.formatDate = _cercaliagl_view_VUtils$formatDate || {};
cercaliagl.view.VUtils.getDOMRelativePosition = _cercaliagl_view_VUtils$getDOMRelativePosition || {};
cercaliagl.view.VUtils.isMobile = _cercaliagl_view_VUtils$isMobile || {};
cercaliagl.view.VWeatherInformation = $cercaliagl$view$VWeatherInformation || {};
cercaliagl.view.VWidgetPois = $cercaliagl$view$VWidgetPois || {};
cercaliagl.view.VWidgetRouting = $cercaliagl$view$VWidgetRouting || {};
cercaliagl.view.VWidgetSearch = $cercaliagl$view$VWidgetSearch || {};
cercaliagl.view.VZBEPopup = $cercaliagl$view$VZBEPopup || {};
cercaliagl.view.VZoom = $cercaliagl$view$VZoom || {};

export default cercaliagl;